/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Pair } from './pair';

/**
 * LP trade DTO
 */
export interface LpTradeDto {
  lpName: string;
  routeOrderId?: number;
  orderId?: number;
  side: LpTradeDto.SideEnum;
  executedQty: number;
  executedPrice: number;
  timestamp: string;
  pair: Pair;
  clientName: string;
  canceled: boolean;
}
export namespace LpTradeDto {
  export const SideEnum = {
    Buy: 'BUY',
    Sell: 'SELL',
  } as const;
  export type SideEnum = (typeof SideEnum)[keyof typeof SideEnum];
}
